import React, { FC, useEffect } from 'react'
import { push } from 'connected-react-router'
import { Link } from 'react-router-dom'
import { FormikHelpers } from 'formik'

import Form from '../../components/Form'
import CustomButton from '../../components/UI/Buttons/CustomButton'
import TermsAndConditions from '../../components/TermsAndConditions'
import ButtonGoogleAuth from '../../components/ButtonGoogleAuth'
import ButtonAppleAuth from '../../components/ButtonAppleAuth';
import TextInput from '../../components/UI/Inputs/TextInput'
import { TLoginFormValues } from '../../models/form'
import ErrorMessage from '../../components/UI/Tooltips/ErrorMessage'

import { useDispatch, useSelector } from '../../store'
import { resetAuthErrorAction } from '../../store/auth/slice'
import { signInThunk } from '../../store/auth/thunks'
import { NON_AUTH_ROUTE } from '../App/routes'

interface LoginPageProps {}

const LoginPage: FC<LoginPageProps> = () => {
  const dispatch = useDispatch()
  const { inProgress, error } = useSelector((state) => ({
    inProgress: state.auth.inProgress,
    error: state.auth.error
  }))

  const setUpForm = {
    initialValues: { email: '', password: '' },
    validation: 'user',
    onSubmit: async (values: TLoginFormValues, actions: FormikHelpers<TLoginFormValues>) => {
      await dispatch(signInThunk(values))
    }
  }

  useEffect(
    () => () => {
      dispatch(resetAuthErrorAction())
    },
    [dispatch]
  )

  return (
    <div className='authentication-page'>
      <div className='authentication-page__navigation-button'>
        Don't have an account?{' '}
        <CustomButton
          button='secondary'
          size='xs'
          onClick={() => dispatch(push(NON_AUTH_ROUTE.SIGNUP))}
        >
          Sign Up
        </CustomButton>
      </div>
      <div className='authentication-page__form'>
        <div className='authentication-page__form__title'>Login</div>
        <Form {...setUpForm}>
          <TextInput label='Email' name='email' type='email' placeholder='Enter your email' />
          <TextInput
            name='password'
            label='Password'
            type='password'
            placeholder='Enter your password'
          >
            <Link
              to={NON_AUTH_ROUTE.RESET_PASSWORD}
              className='authentication-page__form__forgot-pass'
            >
              Forgot password
            </Link>
          </TextInput>
          <CustomButton inProgress={inProgress} button='primary' size='big' type='submit'>
            Submit
          </CustomButton>
        </Form>
        {error && <ErrorMessage text={error.error.message} />}
        <div className='authentication-page__form__text'>or</div>
        <ButtonGoogleAuth />
        {/* <ButtonAppleAuth/> */}
      </div>
      <TermsAndConditions text={'By signing in or creating an account, you agree with our'}/>
    </div>
  )
}

export default LoginPage
